<div class="e-docs-overview">
  <h1 class="c-h1">{{'DOCUMENTS.electronic_documents.title' | translate}}</h1>

  <div class="e-docs-intro">
    <myabvv-introduction [introduction]="'DOCUMENTS.electronic_documents.introduction' | translate"></myabvv-introduction>
  </div>

  <!-- filters component -->
  <myabvv-filter [isLoading]="(state$ | async)?.loading" (applyFilterEvent)="onApplyFilter()"
    (reinitializeFiltersEvent)="onReinitializeFilters()">
    <myabvv-date-filter class="l-grid__unit  l-grid__unit--4of12@medium"
      [datePickerOptionsDate]="datePickerOptionsStartDate" (changeDateEvent)="onChangeStartDate($event)"
    [date]="startMonth" [label]="'CALENDAR.from' | translate"></myabvv-date-filter>
    <myabvv-date-filter class="l-grid__unit  l-grid__unit--4of12@medium"
      [datePickerOptionsDate]="datePickerOptionsEndDate" (changeDateEvent)="onChangeEndDate($event)"
    [date]="endMonth" [label]="'CALENDAR.till' | translate"></myabvv-date-filter>
    <myabvv-dropdown-filter class="l-grid__unit l-grid__unit--4of12@medium"
      (changeValueEvent)="onChangeType($event)" [values]="types"
    [label]="'DOCUMENTS.electronic_documents.type' | translate"></myabvv-dropdown-filter>
  </myabvv-filter>

  @if (state$ | async; as state) {
    @if (state.loading) {
      <myabvv-loader [message]="'GENERAL.busy_loading' | translate"></myabvv-loader>
    }
    <myabvv-alert [condition]="state.error" [message]="'USER_FEEDBACK.error_occurred'" [type]="'error'"></myabvv-alert>
    @if (!hasDocuments(state.data) && !state.error && !state.loading) {
      <div class="info-card-empty">
        <i class="fa fa-inbox info-card-empty__icon"></i>
        <span>{{ 'DOCUMENTS.electronic_documents.no_data' | translate }}</span>
      </div>
    }

    @if (hasDocuments(state.data) && !state.loading) {
      <!-- Timeline View -->
      <div class="timeline">
        @for (document of sortedDocuments(); track document.ticketNumberXL; let isFirst = $first; let isLast = $last) {
          <div class="timeline__item">
            <!-- Timeline connector -->
            <div class="timeline__connector">
              <div class="timeline__line timeline__line--top" [class.timeline__line--hidden]="isFirst"></div>
              <div class="timeline__dot">
                <i class="fa fa-file-alt"></i>
              </div>
              <div class="timeline__line timeline__line--bottom" [class.timeline__line--hidden]="isLast"></div>
            </div>

            <!-- Timeline content (compact single row) -->
            <div class="timeline__content" (click)="onGoToDetail(document.ticketNumberXL)" (keyup.enter)="onGoToDetail(document.ticketNumberXL)" role="button" tabindex="0">
              <div class="timeline__row">
                <div class="timeline__month">
                  {{('CALENDAR.full_month.' + (document.referenceMonth | date:'M') | translate | capitalCase) + ' ' + (document.referenceMonth | date:'yyyy')}}
                </div>
                <span class="timeline__doc-badge">
                  {{document.documentType}}
                </span>
                <i class="fa fa-chevron-right timeline__arrow"></i>
              </div>
            </div>
          </div>
        }
      </div>
    }

    @if (activeYear() && !state.loading && !state.error) {
      <myabvv-pagination [pages]="listOfYear()" [activePage]="activeYear()"
      (selectPageEvent)="getPartialElectronicDocumentsOverview($event)"></myabvv-pagination>
    }
  }

</div>
